import { readerImage } from '@/asset/js/utils';
import {
  fetchVsDrawAwardList,
  fetchVsDragonBoatInfo,
  fetchVsDragonBoatDraw,
  fetchVsDragonBoatFloat,
  fetchVsDragonBoatRank,
  fetchVsDragonBoatJoinCamp,
  fetchVsDragonBoatEditCamp,
  fetchVsDragonBoatTotalRank,
  fetchVsDragonBoatPotValue,
  fetchVsDragonBoatGiftFloat,
} from '@/services/activity';
import { Toast } from 'antd-mobile';
import { CUR_RANK_TAB_TYPE } from '..';

export default {
  namespace: 'luckyRankVs',
  state: {
    activityId: 0,
    title: '',
    titleUrl: '',
    rules: '',
    changed: null,
    selfCamp: null,
    endTime: 0,
    activityStatus: null,
    limitGiftList: [],
    leftRewards: [],
    rightRewards: [],
    extraRewards: [],
    leftRank: 0,
    rightRank: 0,
    lastId: null,
    selfInfo: {},
    ranks: [],
    taskList: [],
    awardList: [],
    coinRank: [],
    coinValue: 0,
    drawFloadList: [],
    recordList: [],
    extraRewardLimit: 0,
    jackpotValue: 0,
    pageNum: 1,
    pageSize: 1000,
    isMore: false,
    dailyTaskRules: '',
  },
  reducers: {
    updateInfo(state, { payload }) {
      const limitGiftList = [];
      if (payload.limitedGiftsForCoins && payload.limitedGiftsForCoins.length) {
        payload.limitedGiftsForCoins.forEach(item => {
          limitGiftList.push({ ...item, gem: false });
        });
      }
      if (payload.limitedGiftsForRedDiamond && payload.limitedGiftsForCoins.length) {
        payload.limitedGiftsForRedDiamond.forEach(item => {
          limitGiftList.push({ ...item, gem: true });
        });
      }
      return {
        ...state,
        activityId: payload.activityId || '',
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        changed: payload.changed || 0,
        selfCamp: payload.selfCamp || 0,
        endTime: payload.endTime || 0,
        activityStatus: payload.activityStatus || 0,
        limitGiftList: limitGiftList || '',
        leftRewards: payload.leftRewards || [],
        rightRewards: payload.rightRewards || [],
        extraRewards: payload.extraRewards || [],
        awardList: payload.luckyDrawAwardList || [],
        coinRank: payload.coinRank || [],
        coinValue: payload.coinValue || '',
        extraRewardLimit: payload.extraRewardLimit || 0,
        dailyTaskRules: payload.dailyTaskRules || '',
      };
    },
    updateDrawFloadList(state, { payload }) {
      return {
        ...state,
        drawFloadList: payload,
      };
    },
    updateTaskList(state, { payload }) {
      return {
        ...state,
        taskList: payload,
      };
    },
    updateList(state, { payload }) {
      let list = payload.force ? [] : [...state.ranks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.selfInfo && payload.selfInfo.userId) {
        selfInfo = payload.selfInfo;
      }
      return {
        ...state,
        selfInfo: selfInfo,
        ranks: list,
        lastId: lastId,
      };
    },
    updateCamp(state, { payload }) {
      return {
        ...state,
        changed: payload.changed || 0,
        selfCamp: payload.selfCamp || 0,
      };
    },
    updateCampScore(state, { payload }) {
      return {
        ...state,
        leftRank: payload.leftRank || 0,
        rightRank: payload.rightRank || 0,
      };
    },
    updateRecordList(state, { payload }) {
      let newList = payload.force ? [] : [...state.recordList];
      if (payload.records && payload.records.length) {
        newList = [...newList, ...payload.records];
      }
      return {
        ...state,
        recordList: newList,
        pageNum: payload.pageNum,
        isMore: newList.length < payload.total,
      };
    },
    updateJackpotValue(state, { payload = {} }) {
      return {
        ...state,
        jackpotValue: payload.jackpotValue || 0,
      };
    },
    updateRemainTimes(state, { payload = [] }) {
      return {
        ...state,
        remainTimes: payload.remainNum || 0,
      };
    },
    updateDiaLog(state, { payload = [] }) {
      return {
        ...state,
        disableDialog: payload.disableDialog,
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(fetchVsDragonBoatInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      if (data) {
        for (let i = 0; i < data.luckyDrawAwardList.length; i++) {
          const { width, height } = yield readerImage(data.luckyDrawAwardList[i].url);
          let w = 55;
          let h = 55;
          let t = 15;
          if (width > height) {
            h = (height / width) * w;
            t = (55 - h) / 2 + t;
          } else if (width < height) {
            w = (width / height) * h;
          } else {
            w = 55;
            h = 55;
          }
          data.luckyDrawAwardList[i].w = w;
          data.luckyDrawAwardList[i].h = h;
          data.luckyDrawAwardList[i].t = t;
        }
        yield put({
          type: 'updateInfo',
          payload: { ...data },
        });
      }
      return true;
    },
    *draw({ payload }, { call }) {
      const { error, data, code } = yield call(fetchVsDragonBoatDraw, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    // *getDrawFloatList({ payload }, { put, call }) {
    //   const { data, error } = yield call(fetchVsDragonBoatFloat, payload);
    //   if (error) {
    //     yield put({
    //       type: 'updateDrawFloadList',
    //       payload: [],
    //     });
    //     Toast.show({
    //       content: error,
    //     });
    //     return error;
    //   }
    //   if (data) {
    //     yield put({
    //       type: 'updateDrawFloadList',
    //       payload: data,
    //     });
    //   }
    //   return data.length ? data : [];
    // },
    *getDrawFloatList({ payload }, { call }) {
      const { error, data } = yield call(fetchVsDragonBoatFloat, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return data.length ? data : [];
      } else {
        return false;
      }
    },
    *getGiftFloatList({ payload }, { call }) {
      const { error, data } = yield call(fetchVsDragonBoatGiftFloat, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return data.length ? data : [];
      } else {
        return false;
      }
    },
    *getList({ payload }, { call, put, select }) {
      const { lastId, leftRank, rightRank, jackpotValue } = yield select(state => state.luckyRankVs);
      const { error, data } = yield call(fetchVsDragonBoatRank, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      // if (payload.force) {
      //   const len = data.ranks.length;
      //   let count = 5;
      //   if (len < 5) {
      //     count = len;
      //   }
      //   let totalCanValue = 0;
      //   for (let i = 0; i < count; i++) {
      //     totalCanValue += data.ranks[i].score;
      //   }
      //   if (payload.camp === CUR_RANK_TAB_TYPE.SOUTH) {
      //     if (leftRank > rightRank) {
      //       data.ranks.forEach((item, index) => {
      //         if (index < count) {
      //           item.potValue = ((item.score / totalCanValue) * jackpotValue).toFixed(3);
      //         }
      //       });
      //       if (data.selfInfo.ranking && data.selfInfo.ranking <= count) {
      //         data.selfInfo.potValue = data.ranks[data.selfInfo.ranking - 1].potValue;
      //       }
      //     }
      //   } else {
      //     if (leftRank < rightRank) {
      //       data.ranks.forEach((item, index) => {
      //         if (index < count) {
      //           item.potValue = ((item.score / totalCanValue) * jackpotValue).toFixed(3);
      //         }
      //       });
      //       if (data.selfInfo.ranking && data.selfInfo.ranking <= count) {
      //         data.selfInfo.potValue = data.ranks[data.selfInfo.ranking - 1].potValue;
      //       }
      //     }
      //   }
      // }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *joinCamp({ payload }, { call }) {
      const { error, data, code } = yield call(fetchVsDragonBoatJoinCamp, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *editCamp({ payload }, { call }) {
      const { error, data, code } = yield call(fetchVsDragonBoatEditCamp, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *getCamp({ payload }, { call, put }) {
      const { error, data } = yield call(fetchVsDragonBoatInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateCamp',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      if (data) {
        yield put({
          type: 'updateCamp',
          payload: { ...data },
        });
      }
      return true;
    },
    *getCampTotalScore({ payload }, { call, put }) {
      const { error, data } = yield call(fetchVsDragonBoatTotalRank, payload);
      if (error || !data) {
        yield put({
          type: 'updateCampScore',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      if (data) {
        yield put({
          type: 'updateCampScore',
          payload: { ...data },
        });
      }
      return true;
    },
    *getRecordList({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.luckyRankVs);
      const { error, data } = yield call(fetchVsDrawAwardList, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      if (error || !data) {
        yield put({
          type: 'updateRecordList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateRecordList',
        payload: { ...data, pageNum: payload.force ? 2 : pageNum + 1, force: payload.force, type: payload.type },
      });
      return true;
    },
    *getRecordListLoadMore({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.luckyRankVs);
      const { error, data } = yield call(fetchVsDrawAwardList, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      if (error || !data) {
        yield put({
          type: 'updateRecordList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateRecordList',
        payload: { ...data, pageNum: payload.force ? 2 : pageNum + 1, force: payload.force, type: payload.type },
      });
      return true;
    },
    *getPotValue({ payload }, { call, put }) {
      const { error, data } = yield call(fetchVsDragonBoatPotValue, payload);
      if (error || !data) {
        yield put({
          type: 'updateJackpotValue',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      if (data) {
        yield put({
          type: 'updateJackpotValue',
          payload: data,
        });
      }
      return true;
    },
  },
};
